const GRADE_LEVELS = {
    FRESHMAN: 3,
    SOPHOMORE: 2,
    JUNIOR: 1,
    SENIOR: 0,
}

export default GRADE_LEVELS
